import { MapPin, Phone, MessageCircle, Mail, Instagram } from "lucide-react";
import { Reveal } from "./Reveal";
import { scrollToId } from "../lib/booking";

const contactos = [
  { icon: MapPin, label: "Carrera 40 #22A-77, Bogotá, Colombia", sub: "Barrio Galerías, frente al Edificio Ágora – Corferias", testid: "footer-address" },
  { icon: Phone, label: "WhatsApp / Teléfono", sub: "+57 304 564 6235", testid: "footer-phone" },
];

const nav = [
  { label: "Para Ella", id: "experiencia-ella" },
  { label: "Para Él", id: "experiencia-el" },
  { label: "DUO", id: "experiencias-duo" },
  { label: "Reserva", id: "reserva" },
];

const SiteFooter = () => {
  return (
    <footer
      data-testid="site-footer"
      className="relative bg-[#faf9f6] px-6 pt-24 pb-10 md:px-16"
    >
      <div className="mx-auto max-w-6xl">
        <Reveal>
          <img
            src="/images/duo_experience_b.svg"
            alt="DUO Experience"
            className="h-10 w-auto object-contain md:h-12"
          />
          <p className="mt-6 max-w-md font-cormorant text-xl italic text-[#6b615c]">
            Spa de lujo unisex · Para Ella & Para Él · Bogotá
          </p>
        </Reveal>

        <div className="mt-16 grid gap-12 md:grid-cols-[1.4fr_1fr]">
          <div className="grid gap-8 sm:grid-cols-2">
            {contactos.map((c) => (
              <div key={c.label} data-testid={c.testid} className="flex items-start gap-4">
                <c.icon className="mt-1 h-5 w-5 text-[#593d36]" />
                <div>
                  <p className="text-sm font-medium text-[#3a3939]">{c.label}</p>
                  {c.testid === "footer-phone" ? (
                    <a href="https://wa.me/573045646235" target="_blank" rel="noopener noreferrer" className="text-xs text-[#8c8078] hover:text-[#593d36] transition-colors">{c.sub}</a>
                  ) : (
                    <p className="text-xs text-[#8c8078]">{c.sub}</p>
                  )}
                </div>
              </div>
            ))}
          </div>

          <div className="flex flex-col gap-3 md:items-end">
            <span className="label text-[#593d36]">Navegación</span>
            {nav.map((n) => (
              <button
                key={n.id}
                data-testid={`footer-nav-${n.id}`}
                onClick={() => scrollToId(n.id)}
                className="font-serif-display text-2xl text-[#3a3939] transition-colors hover:text-[#593d36]"
              >
                {n.label}
              </button>
            ))}
            <a
              data-testid="footer-instagram"
              href="https://www.instagram.com/duoexperiencespa"
              target="_blank"
              rel="noopener noreferrer"
              className="mt-4 inline-flex items-center gap-2 text-sm text-[#6b615c] transition-colors hover:text-[#593d36]"
            >
              <Instagram className="h-4 w-4" /> @duoexperiencespa
            </a>
          </div>
        </div>

        <div className="mt-20 flex flex-col items-start justify-between gap-4 border-t border-[#3a3939]/10 pt-8 text-xs text-[#8c8078] md:flex-row md:items-center">
          <p>© {new Date().getFullYear()} DUO Experience · Todos los derechos reservados.</p>
          <p>Bogotá · Colombia · Hecho con cuidado y detalle.</p>
        </div>
      </div>
    </footer>
  );
};

export default SiteFooter;
